import {
  ApiResponse,
  ThreeDSChallenge,
  ThreeDSChallengeLogResponse,
  ThreeDSChallengeStatus,
  ThreeDSChallengeSource,
} from '@mygate/common';
import { api } from './api';

class ThreeDSService {
  async getChallengeLog(params?: {
    status?: ThreeDSChallengeStatus;
    userId?: string;
    source?: ThreeDSChallengeSource;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<ThreeDSChallengeLogResponse>> {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.set('status', params.status);
    if (params?.userId) queryParams.set('userId', params.userId);
    if (params?.source) queryParams.set('source', params.source);
    if (params?.startDate) queryParams.set('startDate', params.startDate);
    if (params?.endDate) queryParams.set('endDate', params.endDate);
    if (params?.page) queryParams.set('page', String(params.page));
    if (params?.limit) queryParams.set('limit', String(params.limit));
    const query = queryParams.toString();
    return api.get(`/api/staff/three-ds/log${query ? `?${query}` : ''}`);
  }

  async getChallengeDetail(id: string): Promise<ApiResponse<ThreeDSChallenge>> {
    return api.get(`/api/staff/three-ds/log/${id}`);
  }

  async triggerTestChallenge(params: {
    userId: string;
    merchantName: string;
    amount: number;
    currencyCode?: string;
    merchantCountry?: string;
  }): Promise<ApiResponse<ThreeDSChallenge>> {
    return api.post('/api/staff/three-ds/test', params);
  }
}

export const threeDSService = new ThreeDSService();
